import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-fullpage-loading',
    imports: [],
    animations: [
        trigger('loadingState', [
            state('loading', style({
                opacity: 1
            })),
            state('idle', style({
                opacity: 0
            })),
            transition('idle => loading', animate('500ms ease-in')),
            transition('loading => idle', animate('500ms ease-in')),
        ])
    ],
    templateUrl: './fullpage-loading.component.html',
    styleUrl: './fullpage-loading.component.css'
})
export class FullpageLoadingComponent {
  @Input() loading: boolean = false;
  @Input() text: string = '';
}
